import schema from '../../../assets/formSchemas/formDataSchema.json'
import formFields from '../../../assets/formSchemas/formFields.json'

export default {
  SIGNEDUP(state, payload) {
    state.signedUp = true
  },
  SIGNUPERROR(state, payload) {
    state.signedUp = false
    state.verified = false
    payload ? state.verifyError = payload : state.verifyError = ''
  },
  SIGNUPFIELDSET(state, payload) {
    const fieldset = formFields.signup
    const signupProperties = schema['nutricom.Signup'].properties
    let retArray = []
    const validators = payload ? payload.validators : null
    fieldset.forEach(function (field) {
      if (signupProperties.hasOwnProperty(field.name)) {
        if (validators && validators[field.name]) signupProperties[field.name].validator = validators[field.name]
        retArray.push(Object.assign({}, signupProperties[field.name], field))
      } else {
        retArray.push(field)
      }
    })
    state.signUpSchema = retArray
  },
  VERIFIED(state, payload) {
    state.verified = true
  },
  VERIFICATIONFIELDSET(state, payload) {
    const fieldset = formFields.verification
    const verificationProperties = schema['OAuth2.PasswordReset'].properties
    const retArray = []

    fieldset.forEach(function (field) {
      if (verificationProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, field, verificationProperties[field.name]))
      }
    })
    state.verificationSchema = retArray
  },
  RESENDCODEFIELDSET(state, payload) {
    state.resendCodeSchema = formFields.resendCode
  },
  BIOMETRICSFIELDSET(state, payload) {
    const activities = payload
    const fieldset = formFields.biometrics
    const biometricsProperties = schema['biometrics'].properties
    const retArray = []

    fieldset.forEach(function (field) {
      if (field.name === 'sportsPlayed') {
        field.options = activities
      }
      retArray.push(Object.assign({}, biometricsProperties[field.name], field))
    })

    state.biometricsSchema = retArray
  },
  BIOMETRICSENTERED(state, payload) {
    state.biometricsEntered = payload
  },
  BIOMETRICSERROR(state, payload) {
    state.biometricsEntered = false
  },
  ADDMULTITEXTVALUES (state, payload) {
    state.multiTextValues.push({ text: '' })
  },
  POPULATEMULTITEXTVALUES (state, payload) {
    state.multiTextValues = []
    let i = 0
    let v = payload ? Array.from(payload) : []
    let vLength = v.length

    for (i = 0; i < vLength; i++) {
      if (typeof v[i] === 'object' && v[i].hasOwnProperty('text') === true) {
        state.multiTextValues.push(v[i])
      } else {
        state.multiTextValues.push({ text: v[i] })
      }
    }
    if (state.multiTextValues.length === 0) {
      state.multiTextValues.push({ text: '' })
    }
  },
  RESETMULTITEXTVALUES (state, payload) {
    state.multiTextValues = [{text: ''}]
  },
  SPLICEMULTITEXTVALUES (state, payload) {
    state.multiTextValues.splice(payload, 1)
  },
  UPDATEMULTITEXTVALUES (state, payload) {
    let i = 0
    let valuesLength = payload.length
    let textValues = []
    for (i = 0; i < valuesLength; i++) {
      if (payload[i].hasOwnProperty('text') === true && payload[i].text !== '') {
        textValues.push(payload[i].text)
      }
    }
    state.multiTextVals = textValues
  },
  SETFORMDATA (state, payload) {
    state.formData = payload
  },
  UPDATEFORMDATA (state, payload) {
    state.formData[payload.fieldName] = payload.fieldValue
  },
  CODESENT(state, payload) {
    state.codeSent = payload
  },
  LONGFORMHTML(state, payload) {
    state.longFormHtml = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/signup/mutations.js